import React from "react"
import responsive from "@main/hoc/responsive";
import desktop from "./desktop.js"
import mobile from "./mobile.js"

export default React.memo(
	responsive({mobile, default: desktop})
);
